import type { CastImage } from "@/types/aggregate-items";

type CastImageSize = "100" | "300" | "640" | "800" | "1600";
type CastImageWidth = "300" | "400" | "500" | "1600";
type CastImageExt = ".webp" | ".jpg" | ".png";
type CastImageQuality = "q-40" | "q-60" | "q-80" | "q-90";

type ImageUrlOptions = {
  imageSize?: CastImageSize;
  imageWidth?: CastImageWidth;
  quality?: CastImageQuality;
  ext?: CastImageExt;
};

type ImageUrlFunction = (image: CastImage, options?: ImageUrlOptions) => string;

export const imageUrl: ImageUrlFunction = (
  image: CastImage,
  options: ImageUrlOptions = {},
): string => {
  const { imageSize = "300", imageWidth, quality, ext = ".webp" } = options;
  const url = new URL(image.url);
  const origin = url.origin;
  const sizePrefix = imageWidth ? `s-w${imageWidth}` : `s-l${imageSize}`;
  const qualitySuffix = quality ? `/${quality}` : "";
  const filename = `${sizePrefix}${qualitySuffix}${ext}`;
  return `${origin}/images/g/${image.zoomGuid}/${filename}`;
};
